import { useNavigate } from 'react-router-dom';
import { WarningAmberRounded } from '@mui/icons-material';

import Alert from '../../../components/atoms/alert';
import Button from '../../../components/atoms/button';
import useAuth from '../../../context/AuthContext';
import useWorkspaceInvite from '../../../context/WorkspaceInviteContext';

const InviteExpiredError = () => {
  const navigate = useNavigate();
  const { setIsInviteUser } = useWorkspaceInvite();
  const { isLoggedIn } = useAuth();

  const handleGoHome = () => {
    navigate('/');
    setIsInviteUser(false);
  };

  return (
    <div>
      <Alert fontSize={24} title="This invite link is no longer available." type="error" icon={<WarningAmberRounded style={{ fontSize: 40 }} />} />
      <p>Please check with the person who shared it with you to see if there’s new link available.</p>
      {isLoggedIn && <Button primary outlined onClick={handleGoHome}>Back to Home</Button>}
    </div>
  );
};

export default InviteExpiredError;
